const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const imgSrc = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);

// Verkleinert Fotos im Browser (max. 1600px, JPEG) – schneller Upload, keine Größenlimits
export const compressImage = (file, maxSide = 1600, quality = 0.85) =>
  new Promise((resolve) => {
    if (!file.type.startsWith("image/") || file.type === "image/gif") return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob(
        (blob) => resolve(blob ? new File([blob], "bild.jpg", { type: "image/jpeg" }) : file),
        "image/jpeg",
        quality
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });

export const errorText = (err, fallback) => {
  const s = err?.response?.status;
  if (s === 401 || s === 403) return "Sitzung abgelaufen – bitte erneut als Admin anmelden.";
  if (s === 413) return "Datei zu groß.";
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return `Ungültige Eingabe: ${d[0].loc?.slice(-1)[0] || ""} – ${d[0].msg}`;
  if (!err?.response) return "Keine Verbindung zum Server.";
  return fallback;
};
